import { namespaceActions } from 'modules/redux-utils'
import { NAME } from './constants'

export const SESSION_INITIALIZED = 'SESSION_INITIALIZED'
export const SESSION_INVALIDATE = 'SESSION_INVALIDATE'

export default namespaceActions(NAME)([SESSION_INITIALIZED, SESSION_INVALIDATE])
